module.exports = __webpack_public_path__ + "img/w3_location_grey.8922218a.png";